import React from 'react';
import { Url } from 'url';
import { Image } from 'antd';
import styles from './LogoText.module.scss';

type LogoTextProps = {
  clientColor: string;
  logo: Url | undefined;
  title?: string;
  description?: string;
};

const LogoText: React.FC<LogoTextProps> = ({ logo, clientColor, title, description }) => {
  return (
    <div className={styles.contentWrap}>
      <div className={styles.logoCont} style={{ backgroundColor: clientColor }}>
        <div className={styles.logoWrap}>
          <Image preview={false} src={logo?.toString()} alt="Company logo" className={styles.logo} />
        </div>
      </div>
      <div className={styles.textWrap}>
        <h3 className={styles.title}>{title || 'Αναζητάμε συνεχώς ανθρώπους που μαζί τους κατακτάμε νέες κορυφές.'}</h3>
        <p className={styles.description}>
          {description ||
            'Για να εμπνεύσουμε την επιτυχία εντός και εκτός της εργασίας, ' +
              'επενδύουμε στην εταιρική κουλτούρα προσφέροντας παράλληλα στους ' +
              'εργαζόμενούς μας ανταγωνιστικές οικονομικές και ασφαλιστικές αποδοχές. ' +
              'Φροντίζουμε για τη διατήρηση ενός υγειούς κλίματος εργασίας, ' +
              'συνεργασίας και επαγγελματικής-προσωπικής ισορροπίας. ' +
              'Με δυνατότητες επαγγελματικής εξέλιξης και σταθερά ανοδική πορεία, ' +
              'όραμά μας είναι όλοι οι εργαζόμενοί μας να κατακτήσουν πλήρως τις δυνατότητές τους.'}
        </p>
      </div>
    </div>
  );
};

LogoText.defaultProps = {
  title: '',
  description: '',
};

export default LogoText;
